import { type CSSProperties } from 'react';

type ValidCSSProperty = keyof Required<CSSProperties>;

export const InheritableTypographyProperties = [
  'color',
  'fontSize',
  'fontWeight',
  'letterSpacing',
  'fontFamily',
  'lineHeight',
  'textDecoration',
] as const satisfies ValidCSSProperty[];

export type InheritableTypographyProperty = (typeof InheritableTypographyProperties)[number];

export const inheritedTypographySx = <
  K extends InheritableTypographyProperty = InheritableTypographyProperty,
>(
  properties?: K[],
): Record<K, 'inherit'> => {
  const props = properties ?? ([...InheritableTypographyProperties] as K[]);
  return props.reduce((acc, prop) => ({ ...acc, [prop]: 'inherit' }), {} as Record<K, 'inherit'>);
};

/**
 * Defines the webkit line-clamp CSS property for text.  The {@link LineClamp} is allowed to be
 * represented as "none" to disable line clamping, in cases where components that wrap the
 * {@link Typography} component provide a default line clamp that needs to be unset in the
 * consumer logic.
 */
export type LineClamp = 'none' | number;
